/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react'
import Modal from 'live/components/ui/Modal'
import i18n from 'live/services/i18n'
import List from 'live/components/ui/List'
import LiveSelect from 'live/components/forms/ui/select'
import globalConfirmation from 'live/services/global-confirmation'
import globalNotification from 'live/services/global-notification'
import { CSVApi, FileMetadata } from '../../api'
import { config } from '../../app'

interface RemapModalProps {
    showModal: boolean
    setShowModal: (show: boolean) => void
    uploadedFile: FileMetadata
    channels: string[]
}

const RemapModal: React.FC<RemapModalProps> = ({
    showModal,
    setShowModal,
    uploadedFile,
    channels
}: RemapModalProps) => {
    const [remapData, setRemapData] = React.useState<Record<string, string>>(uploadedFile.remaps || {})
    const [uploadedFileState, setUploadedFileState] = React.useState<FileMetadata>(uploadedFile)

    const api = new CSVApi(config)

    useEffect(() => {
        if (uploadedFileState !== uploadedFile) {
            setUploadedFileState(uploadedFile)
            setRemapData(uploadedFile.remaps || {})
        }
    }, [])

    const handleSave = async (): Promise<void> => {
        globalConfirmation
            .confirm(
                <span>{i18n('Are you sure you want to save the changes?')}</span>,
                async () => {
                    uploadedFile.remaps = remapData
                    try {
                        const response = await api.updateMetadata({
                            uid: uploadedFile.uid,
                            eventTypeName: uploadedFile.wellboreEventType,
                            fileMetadata: uploadedFile
                        })

                        if (response.status === 200) {
                            globalNotification.success(response.statusText)
                            setShowModal(false)
                        } else {
                            globalNotification.error(response.statusText)
                        }
                    } catch (error) {
                        globalNotification.error(i18n(`An error occurred while updating the file: ${error.message}`))
                    }
                },
                {
                    btnText: i18n('Yes, save')
                }
            )
            .then()
    }

    console.log('uploadedFileState', uploadedFile.mnemonics.keys())

    return (
        <Modal closable show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header>
                <Modal.Title>{i18n('Remap CSV Columns')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* @ts-ignore */}
                <List
                    sort={false}
                    search={false}
                    filter={false}
                    // @ts-ignore
                    items={
                        Array.isArray(uploadedFileState.mnemonics)
                            ? uploadedFileState.mnemonics
                            : Array.from(uploadedFileState.mnemonics || [])
                    }
                    // items={uploadedFileState.mnemonics}
                    // @ts-ignore
                    render={(items: string[]) => {
                        return (
                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {items.map((item, index) => (
                                    <div key={index}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <label style={{ width: '200px', marginRight: 'auto' }}>{`${item} ${
                                                uploadedFile.units[index] !== '' && uploadedFile.units[index] !== item
                                                    ? `(${uploadedFile.units[index]})`
                                                    : ''
                                            }`}</label>
                                            <LiveSelect
                                                style={{ width: '300px', marginLeft: 'auto' }}
                                                disabled={channels === undefined}
                                                placeholder={i18n('Leave empty to use CSV mnemonic')}
                                                options={channels.map(channel => ({
                                                    label: channel,
                                                    value: channel
                                                }))}
                                                value={remapData?.[item]}
                                                onChange={(value: string) => {
                                                    const newRemapData = { ...remapData }
                                                    if (value !== '' && value !== undefined) {
                                                        newRemapData[item] = value
                                                    } else {
                                                        delete newRemapData[item]
                                                    }
                                                    setRemapData(newRemapData)
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    }}
                />
                <hr />
                <label>{`Channels Mapped: ${Object.keys(remapData).length}`}</label>
            </Modal.Body>
            <Modal.Footer>
                <input type={'button'} className={'btn btn-primary'} value={i18n('Save')} onClick={handleSave} />
                <input
                    type={'button'}
                    className={'btn btn-default'}
                    value={i18n('Cancel')}
                    onClick={() => setShowModal(false)}
                />
            </Modal.Footer>
        </Modal>
    )
}

export default RemapModal
